// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CampaignOrderType from "../entity/CampaignOrderType.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as CampaignOrderApiModel from "../api-model/CampaignOrderApiModel.bs.js";

function apiModelToState(res) {
  return List.map((function (order) {
                var data = order.order_date;
                return {
                        order_id: order.order_id,
                        order_type: CampaignOrderType.fromString(order.order_type),
                        order_date: data !== undefined ? Caml_option.some(Timestamp$Catalyst.make(data)) : undefined
                      };
              }), res.orders);
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(CampaignOrderApiModel.t_decode(json), "CampaignOrderApiModel.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
